import { UserLocation } from "../services/location.service";

interface LatLng {
    lat: number;
    lng: number;
}


interface Site {
    geofenceValue: string; // stringified polygon array
}

function isPointInPolygon(point: LatLng, polygon: LatLng[]): boolean {
    // Ray casting algorithm
    let inside = false;
    const x = point.lat;
    const y = point.lng;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].lat, yi = polygon[i].lng;
        const xj = polygon[j].lat, yj = polygon[j].lng;

        const intersect =
            yi > y !== yj > y &&
            x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

        if (intersect) inside = !inside;
    }

    return inside;
}

function isInsideGeofence(point: LatLng, getfenceValue: string) {
    if(!getfenceValue)
        return false;

    let result = false;

    const geofenceObject = JSON.parse(getfenceValue);
    geofenceObject.forEach((polygon: LatLng[]) => {
        if (isPointInPolygon(point, polygon)) {
            result = true;
        }
    });

    return result;
}

function markUsersInsideGeofence(site: Site, users: UserLocation[]): UserLocation[] {
    // Parse the geofence polygon (it's double stringified array)
    const geofence: LatLng[][] = JSON.parse(site.geofenceValue);
    const polygon = geofence[0]; // take the first polygon array

    return users.map(user => {
        if (user.status === 'On') {
            const inside = isPointInPolygon(
                { lat: user.latitude, lng: user.longitude },
                polygon
            );
            return { ...user, inside };
        }
        return { ...user, inside: false };
    });
}


interface ShiftFilter {
    shiftId: any;
}

// Keep only Firebase records that are "On", belong to a real knight in allKnights,
// and (if a shift filter is given) match the currently selected shift.
// Carries over the realtime fields (isEmergency/isLiveStream/timestamp/shiftId/rosterId)
// so callers can build marker state without a second lookup into Firebase.
function mergeFirebaseWithKnights(
    firebaseUserList: any[],
    allKnights: any[],
    currentShift?: ShiftFilter | null
): any[] {
    const onUsers = firebaseUserList.filter(u => u.status === "On");
    const onlineMap = new Map(onUsers.map(u => [u.userId, u]));

    return allKnights
        .filter(u => {
            const online = onlineMap.get(u.id);
            if (!online) return false;
            if (currentShift && online.shiftId !== currentShift.shiftId) return false;
            return true;
        })
        .map(u => {
            const online = onlineMap.get(u.id);
            return {
                ...u,
                id: online.userId,
                latitude: online.latitude,
                longitude: online.longitude,
                // Firebase spells this "emegency" (typo); normalize to isEmergency here so
                // this.users matches the isEmergency/isLiveStream convention the rest of
                // admin.page.ts (addMarkers, addMarkersWithClustering, doClickMarker) uses.
                isEmergency: online.emegency,
                isLiveStream: online.isLiveStream,
                timestamp: online.timestamp,
                shiftId: online.shiftId,
                rosterId: online.rosterId,
            };
        });
}

function syncAndCheckInside(
    firebaseUserList: any[],
    allKnights: any[],
    site: any,
    currentShift?: ShiftFilter | null
): any[] {
    return mergeFirebaseWithKnights(firebaseUserList, allKnights, currentShift).map(u => ({
        ...u,
        inside: isInsideGeofence({ lat: u.latitude, lng: u.longitude }, site.geofenceValue),
    }));
}


function syncOnlineUsers(firebaseUserList: any[], allKnights: any[], currentShift?: ShiftFilter | null): any[] {
    return mergeFirebaseWithKnights(firebaseUserList, allKnights, currentShift);
}

export { markUsersInsideGeofence, syncAndCheckInside, syncOnlineUsers, isPointInPolygon, isInsideGeofence };